import { Store, useStore } from 'vuex';
import constants from '@/utilities/constants';

export const fetchCalendarEvents = (store: Store<any>) => {
  const googleCalendarIntegration = store.getters.getIntegrationInstallations(
    constants.googleCalendarIntegration
  )[0];

  if (googleCalendarIntegration?.id) {
    return store.dispatch('getUpcomingGoogleCalendarEvents', {
      installation_id: googleCalendarIntegration?.id,
    });
  }

  return Promise.reject('missing calendar integration when trying to fetch google cal evetns');
};

export default async function (
  {
    store = useStore(),
    fetchEvents = false,
  }: {
    store?: Store<any>;
    fetchEvents?: boolean;
  } = {} as any
) {
  await store.dispatch('getTeamIntegrationInstallations', {
    integration: constants.googleCalendarIntegration,
  });

  const { calendar_user_notes } = await store.dispatch(
    'getTeamIntegrationsSettings',
    constants.calendarUserNotesSettings
  );

  if (calendar_user_notes) {
    await store.dispatch('setIntegrationSettings', {
      integration: constants.calendarUserNotesSettings,
      settings: calendar_user_notes,
    });
  }

  if (!fetchEvents) return;

  fetchCalendarEvents(store).catch(() => {});
}
